module.exports = "/static/assets/7a7c16facb15bf57beb7e5830a10fe5c.png";